export const DraftRulesHaveChanged = Symbol('DraftRulesHaveChanged');
export type DraftRulesHaveChanged = typeof DraftRulesHaveChanged;
